<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Edit Journey</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9 mt-5">
            <div class="isotope-wrapper">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From Date</label>
                      <date-picker
                        v-model="journey.from_date"
                        :config="fromDateConfig"
                      ></date-picker>
                      <!-- <input
                        class="form-control"
                        v-model="from_date"
                        type="datetime-local"
                        placeholder="Date.."
                      /> -->
                      <!-- <i class="icon_calendar"></i> -->
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>To Date</label>
                      <date-picker
                        v-model="journey.to_date"
                        :config="toDateConfig"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Travelling From</label>
                      <input
                        class="form-control"
                        v-model="journey.travelling_from"
                        type="text"
                        placeholder="Travelling From.."
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Travelling To</label>
                      <input
                        class="form-control"
                        v-model="journey.travelling_to"
                        type="text"
                        placeholder="Travelling To.."
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Journey With</label>

                      <select
                        v-model="journey.journey_type"
                        class="form-control select2"
                      >
                        <option value="">-Select-</option>
                        <option value="friends">Friends</option>
                        <option value="family">Family</option>
                        <option value="self">Self</option>
                        <option value="couple">Couple</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Would You Like To Name of This Journey</label>
                      <input
                        class="form-control"
                        v-model="journey.journey_name"
                        type="text"
                        placeholder="Name of Journey.."
                      />
                    </div>
                  </div>
                </div>

                <div id="pass-info" class="clearfix"></div>
                <button
                  type="submit"
                  class="btn_1 rounded add_top_30 mb-3"
                  @click="update_journey()"
                  :disabled="loading"
                >
                  <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  Next
                </button>
                <!-- <button
                  type="submit"
                  class="btn_1 rounded add_top_30 purchase"
                  @click="journey('finish')"
                  :disabled="loading"
                >
                  <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                  ></span>
                  Finish Journey
                </button> -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "../services/index";
import Sidebar from "../layouts/Sidebar.vue";
import Frontendlayout from "../layouts/Frontendlayout.vue";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      fromDateConfig: {
        format: "DD/MM/YYYY hh:mm a",
        useCurrent: false,
        minDate: new Date(),
      },
      toDateConfig: {
        format: "DD/MM/YYYY hh:mm a",
        useCurrent: false,
        minDate: new Date(),
      },
      journey: {
        from_date:'',
        to_date: ''
      },
      id: null,
    };
  },
  beforeMount() {
    this.checkToken();
    this.getJourneydetails();
  },
  methods: {
    getJourneydetails() {
      let id = this.$router.currentRoute.params.id;
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
        API.get("userjourney/get_journey_details/" + id, {
          headers: { Authorization: token },
        })
        .then((res) => {
          this.journey = res.data;
          this.journey.from_date = moment(
            res.data.from_date,
            "YYYY-MM-DD H:mm:ss"
          ).format("DD/MM/YYYY hh:mm a");
          this.journey.to_date = moment(
            res.data.to_date,
            "YYYY-MM-DD H:mm:ss"
          ).format("DD/MM/YYYY hh:mm a");
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setToDate(e) {
      alert(e.target.val());
    },
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },

    update_journey() {
      this.loading = true;
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      const form = new FormData();
      // alert(this.from_date);
      // alert(moment(this.from_date, "DD/MM/YYYY h:m a", true).isValid());
      if (moment(this.from_date, "DD/MM/YYYY h:m a", true).isValid() == true) {
        var date1 = moment(this.from_date, "DD/MM/YYYY h:m a");
        var date2 = moment(this.to_date, "DD/MM/YYYY h:m a");
        this.from_date = moment(this.from_date, "DD/MM/YYYY h:m a").format(
          "YYYY-MM-DD H:mm:ss"
        );

        this.to_date = moment(this.to_date, "DD/MM/YYYY h:m a").format(
          "YYYY-MM-DD H:mm:ss"
        );
        //alert(this.from_date);
        if (date1 > date2) {
          Toast.fire({
            icon: "Error",
            title: "To Date cannot be smaller",
          });
          this.loading = false;

          return false;
        }
      }
      let id = this.$router.currentRoute.params.id;
      //alert(this.from_date + " " + this.to_date);
      //form.append("id", id);
      form.append("from_date", this.journey.from_date);
      form.append("to_date", this.journey.to_date);
      form.append("travelling_from", this.journey.travelling_from);
      form.append("travelling_to", this.journey.travelling_to);
      form.append("journey_type", this.journey.journey_type);
      form.append("journey_name", this.journey.journey_name);
      const token = "Bearer " + localStorage.getItem("token");

      API.post("/userjourney/update_journey/" + id, form, {
        headers: { Authorization: token },
      })
        .then((res) => {
          this.loading = false;
          console.log(res.data.messages);

          if (res.data.status == 200) {
            this.msg =
              "Your journey has been updated. Please add destinations to avail offers";
            Toast.fire({
              icon: "Success",
              title: res.data.messages,
            });
            //const id = window.btoa(res.data.data.user_journey_id);
            // if (type == "finish") {
            //   this.$router.push("/my-journey");
            // } else {
            //   this.$router.push("/add-destination-list/" + id);
            // }
            this.$router.push("/journey-categories/" + id);
          } else {
            let errorText = "";
            let arrayFailed = [];
            if (typeof res.data.message === "object") {
              arrayFailed = Object.entries(res.data.message).map((arr) => ({
                fieldName: arr[0],
                message: arr[1],
              }));
              arrayFailed.forEach((val) => {
                errorText = errorText + val.message + "<br>";
              });
            } else {
              errorText = res.data.message;
            }

            Toast.fire({
              icon: "Error",
              title: errorText,
            });
          }
        })
        .catch((err) => {
          Toast.fire({
            icon: "Error",
            title: err.response.data.messages.error,
          });
        });
      //axios
      return false;
    },
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
};
</script>
<style  scoped>
.custom-search-input-2 input {
  border: 1px solid #d2d8dd !important;
}
.custom-search-input-2 {
  padding: 20px !important;
}
.form-group {
  margin-bottom: 30px;
}
.custom-search-input-2 i {
  top: 35px;
  height: unset !important;
  line-height: unset;
}
.custom-search-input-2 input {
  height: 35px;
}
figure img {
  width: 439px;
  height: 310px;
  margin-top: 17px;
}
.form-check-label {
  position: relative;
  bottom: 5px !important;
}
</style>